import { Family } from './stockWaterfall.walk'

export type StockWaterfallView = 'classic' | 'new'

// The view a v2 plan opens on: New since US154085; Classic stays on the toggle.
// The toggle and this constant go when the transition ends. Nothing is persisted.
export const DEFAULT_STOCK_WATERFALL_VIEW: StockWaterfallView = 'new'

// Handover §2.3, light tokens: one hue per flow family, reusing today's
// meanings (amber = FD, red = SITA, blue = PVA, green = stock policy).
export const FAMILY_COLOURS: Record<Family, string> = {
  amber: '#F59E0B',
  brown: '#8C5A2B',
  red: '#EF4444',
  teal: '#0E9AA7',
  blue: '#1D4ED8',
  slate: '#475569',
}

export const SAFETY_STOCK_COLOUR = '#198754'

export const CHART_COLOURS = {
  surface: '#FFFFFF',
  ink: '#161A20',
  muted: '#7A8190',
  rule: '#C4CAD3',
  grid: '#E8EBEF',
}
